import React from 'react';
import {
  InputLabel,
  FormControl,
  Select,
  FormHelperText,
} from '@material-ui/core';
import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';

export interface SelectInputProps {
  name: string;
  label: string;
  placeholder?: string;
  value: string;
  [key: string]: any;
}

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    formControl: {
      minWidth: 120,
    },
    selectEmpty: {
      marginTop: theme.spacing(2),
    },
  }),
);

const SelectInputField = (props: SelectInputProps) => {
  const {
    label,
    name,
    handleBlur,
    Children,
    onChange,
    labelId,
    value,
    SelectDisplayProps,
    error,
    helperText,
  } = props;
  const classes = useStyles();

  return (
    <FormControl
      variant="outlined"
      error={error}
      className={classes.formControl}
      fullWidth
    >
      <InputLabel>{label}</InputLabel>
      <Select
        value={value}
        onChange={onChange}
        label={label}
        onBlur={handleBlur}
        labelId={labelId}
        name={name}
        inputProps={{
          ...SelectDisplayProps,
        }}
        error={error}
      >
        {Children}
      </Select>
      {helperText && <FormHelperText>{helperText}</FormHelperText>}
    </FormControl>
  );
};
export default SelectInputField;
